import React, { useState, useEffect } from 'react';
import './Navbar.scss';
import rohanSysImg from '../../assets/rohan-systems-pics/logo-removebg-preview.png';
import { 
  CONTACTUS_SECTION_ID, 
  HOME_SECTION_ID, 
  SERVICE_SECTION_ID, 
  TESTIMONIAL_SECTION_ID 
} from '../../utils/Constant';
import { handleScroll } from '../../utils/Utils';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navbarItems = [
    { name: 'Home', type: 'section', id: HOME_SECTION_ID },
    { name: 'About Us', type: 'page', id: '/about' },
    { name: 'Services', type: 'section', id: SERVICE_SECTION_ID },
    { name: 'Testimonials', type: 'section', id: TESTIMONIAL_SECTION_ID },
    { name: 'Accessories', type: 'page', id: '/Accessories' }
  ];

  const [activeSection, setActiveSection] = useState("");

  const handleNavigation = (id, isSection = false) => {
    if (isSection) {
      if (location.pathname === "/") {
        handleScroll(id);
      } else {
        navigate("/");
        setTimeout(() => {
          handleScroll(id);
        }, 400);
      }
    } else {
      navigate(id);
    }
  };

  useEffect(() => {
    if (location.pathname !== "/") return;

    const handleScrollEffect = () => {
      navbarItems.forEach(({ id, type }) => {
        if (type === "section") {
          const section = document.getElementById(id);
          if (section && section.getBoundingClientRect().top <= 100) {
            setActiveSection(id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScrollEffect);
    return () => window.removeEventListener("scroll", handleScrollEffect);
  }, [navbarItems, location.pathname]);

  return (
    <div className="main-nav">
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            {/* Logo */}
            <div 
              className="navbar-brand" 
              onClick={() => handleNavigation(HOME_SECTION_ID, true)} 
              style={{cursor: 'pointer'}}
            >
              <img src={rohanSysImg} className='company-logo' alt="Logo" />
              <span className="Logo-text">Rohan <br />Systems</span>
            </div>

            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent">
              <span className="navbar-toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              {/* Navbar Links */}
              <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                {navbarItems.map(({ name, id, type }) => {
                  let isActive = false;

                  if (type === "section") {
                    isActive = location.pathname === "/" && activeSection === id;
                  } else {
                    isActive = location.pathname === id;
                  }

                  return (
                    <li key={id} className="nav-item">
                      <span 
                        onClick={() =>
                          type === "section"
                            ? handleNavigation(id, true)
                            : handleNavigation(id)
                        }
                        className={`nav-link ${isActive ? "active" : ""}`}
                        style={{cursor: 'pointer'}}
                      >
                        {name}
                      </span>
                    </li>
                  );
                })}
              </ul>

              {/* Navbar Button */}
              <div className="theme-btn">
                <span onClick={() => handleNavigation(CONTACTUS_SECTION_ID, true)}>
                  Get a Quotation
                </span>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Navbar;
